function r(e) {
  return typeof e == "number";
}
export {
  r as isNumber
};
